import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { LogOut, Mail, Menu, Phone, UserRound, X } from "lucide-react";
import tanuragalogo from "../assets/images/tanuraga-logo.png";
import { apiUrl } from "../config/Config";


const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customerdata = useSelector((store) => store.userReducer.customerdata);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isLoggedIn = customerdata && Object.keys(customerdata).length > 0;
  const displayName = customerdata?.fullname || customerdata?.name || "User";
  const firstName = displayName?.split(" ")?.[0] || "User";
  const userInitial = firstName?.charAt(0)?.toUpperCase() || "U";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = async() => {
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + customerdata?.token,
      },
    };

    await axios.post(apiUrl + "customerlogout", {}, headers).catch(() => {});
    dispatch({ type: "customerdata", payload: {} });
    setIsMobileMenuOpen(false);
    navigate("/login");
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="site-header-shell">
      <nav className={`navbar navbar-expand-lg navbar-light bg-white sticky-navbar custom-navbar shadow-sm ${isScrolled ? "navbar-scrolled" : ""}`}>
      <div className="container custom-navbar-container">
        <div className="d-flex align-items-center">
          <Link className="navbar-brand me-4" to="/">
            <img src={tanuragalogo} alt="Tanuraga Logo" className="nav-logo homepage-logo" />
          </Link>

        
        </div>

        <button
          className="navbar-mobile-toggle"
          type="button"
          onClick={() => setIsMobileMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation"
          aria-expanded={isMobileMenuOpen}
        >
          {isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>

        <div className={`navbar-collapse justify-content-end ${isMobileMenuOpen ? "show" : "collapse"}`} id="navbarNav">
          <ul className="navbar-nav align-items-center">
            <li className="nav-item">
              <Link className="nav-link custom-nav-link" to="/" onClick={closeMobileMenu}>Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link custom-nav-link" to="/about" onClick={closeMobileMenu}>About Us</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link custom-nav-link" to="/contact" onClick={closeMobileMenu}>Contact</Link>
            </li>
            

             <li className="nav-item dropdown">
              {
                isLoggedIn ?
                <>
                  <Link
                    className="nav-link dropdown-toggle custom-nav-link header-user-link"
                    to="/profile"
                    id="userDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Hi {firstName}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end header-user-menu" aria-labelledby="userDropdown">
                    <li className="header-user-summary">
                      <div className="header-user-avatar">{userInitial}</div>
                      <div className="header-user-info">
                        <p className="header-user-name">{displayName}</p>
                        {customerdata?.email ? (
                          <p className="header-user-detail">
                            <Mail size={14} />
                            <span>{customerdata.email}</span>
                          </p>
                        ) : null}
                        {customerdata?.number ? (
                          <p className="header-user-detail">
                            <Phone size={14} />
                            <span>{customerdata.number}</span>
                          </p>
                        ) : null}
                      </div>
                    </li>
                    <li>
                      <Link className="dropdown-item header-user-menu-link" to="/profile" onClick={closeMobileMenu}>
                        <UserRound size={16} />
                        <span>My Profile</span>
                      </Link>
                    </li>
                    <li>
                      <button className="dropdown-item header-user-menu-link header-user-logout" type="button" onClick={handleLogout}>
                        <LogOut size={16} />
                        <span>Logout</span>
                      </button>
                    </li>
                  </ul>
                </> :
                <Link className="nav-link custom-nav-link" to="/login" onClick={closeMobileMenu}>Login</Link>
              }
            </li>
          </ul>
        </div>
      </div>
      </nav>
    </header>
  );
};

export default Header;
